var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({width: this.width, height: this.height}),attrs:{"id":_vm.divName,"name":_vm.name,"mapType":_vm.mapType,"latitude":_vm.latitude,"longitude":_vm.longitude,"zoom":_vm.zoom}})])}
var staticRenderFns = []

export { render, staticRenderFns }